<template>
    <section class="cabinet-section">
        <div
            class="d-flex flex-column flex-md-row justify-content-md-between align-items-md-center"
        >
            <h3 class="h3 cabinet-section__dashboard-title">Статистика</h3>

            <div class="cabinet-filter-wrap">
                <select
                    class="select js-selectpicker mr-0 hidden"
                    data-title="Период:"
                    data-width="170px"
                >
                    <option> Сегодня </option>
                    <option> Вчера </option>
                    <option selected> Последние 7 дней </option>
                    <option> Последние 30 дней </option>
                    <option> Этот месяц </option>
                    <option> Этот год </option>
                    <option> Прошлый год </option>
                    <option> Все время </option>
                </select>
            </div>
        </div>

        <div class="dashboard-scrollable__wrap">
            <div class="dashboard-scrollable__content">
                <div class="row dashboard-row">
                    <div class="col-md-4 dashboard-card">
                        <div
                            class="dashboard-card__content d-flex justify-content-between"
                        >
                            <div class="dashboard-card__descr">
                                <div class="dashboard-card__title">
                                    Просмотры
                                </div>
                                <div class="dashboard-card__total">0</div>
                            </div>
                            <div v-if="false" class="dashboard-card__chart">
                                <div class="dashboard-card__diff green">
                                    +35%
                                </div>
                                <canvas
                                    id="chartViews"
                                    class="dashboard-card__chart-line"
                                ></canvas>
                            </div>
                            <div
                                v-else
                                class="dashboard-card__chart dashboard-card__chart--empty"
                            >
                                <div class="dashboard-card__diff gray">0%</div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4 dashboard-card">
                        <div
                            class="dashboard-card__content d-flex justify-content-between"
                        >
                            <div class="dashboard-card__descr">
                                <div class="dashboard-card__title">
                                    Посетители
                                </div>
                                <div class="dashboard-card__total">0</div>
                            </div>
                            <div v-if="false" class="dashboard-card__chart">
                                <div class="dashboard-card__diff red">
                                    -25%
                                </div>
                                <canvas
                                    id="chartVisitors"
                                    class="dashboard-card__chart-line"
                                ></canvas>
                            </div>
                            <div
                                v-else
                                class="dashboard-card__chart dashboard-card__chart--empty"
                            >
                                <div class="dashboard-card__diff gray">0%</div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-4 dashboard-card">
                        <div
                            class="dashboard-card__content d-flex justify-content-between"
                        >
                            <div class="dashboard-card__descr">
                                <div class="dashboard-card__title">
                                    Продажи
                                </div>
                                <div class="dashboard-card__total">0</div>
                            </div>
                            <div v-if="false" class="dashboard-card__chart">
                                <div class="dashboard-card__diff green">
                                    +5%
                                </div>
                                <canvas
                                    id="chartSales"
                                    class="dashboard-card__chart-line"
                                ></canvas>
                            </div>
                            <div
                                v-else
                                class="dashboard-card__chart dashboard-card__chart--empty"
                            >
                                <div class="dashboard-card__diff gray">0%</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- /dashboard-scrollable__content -->
        </div>
        <!-- /dashboard-scrollable__wrap -->
    </section>
</template>

<script>
import Chart from 'chart.js'
import initSelectPicker from '@/mixins/initSelectPicker'

export default {
    name: 'ChartStats',
    mixins: [initSelectPicker],
    mounted() {
        this.initSelectPicker()

        var chartOptions = {
            responsive: true,
            maintainAspectRatio: true,
            // aspectRatio: 1.67,
            legend: {
                display: false
            },
            elements: {
                point: {
                    radius: 0
                }
                // line: {
                //     tension: 0.05
                // }
            },
            scales: {
                xAxes: [
                    {
                        display: false
                    }
                ],
                yAxes: [
                    {
                        display: false,
                        ticks: {
                            beginAtZero: true,
                            min: 0,
                            max: 11,
                            stepSize: 1
                        }
                    }
                ]
            }
        }

        //Просмотры
        // var ctx = document.getElementById('chartViews').getContext('2d')
        // var gradient = ctx.createLinearGradient(0, 0, 0, 400)
        // gradient.addColorStop(0, '#D4FFEC')
        // gradient.addColorStop(0.2, 'rgba(212, 255, 236, 0)')
        // var chartViews = new Chart(ctx, {
        //     type: 'line',
        //     data: {
        //         labels: ['1', '2', '3', '4', '5', '6'],
        //         datasets: [
        //             {
        //                 data: [5, 7, 7, 9, 9.5, 10],
        //                 backgroundColor: gradient,
        //                 borderColor: '#49CC98',
        //                 borderWidth: 2
        //             }
        //         ]
        //     },
        //     options: chartOptions
        // })

        //Посетители
        // var ctx2 = document.getElementById('chartVisitors').getContext('2d')
        // var gradient2 = ctx2.createLinearGradient(0, 0, 0, 400)
        // gradient2.addColorStop(0, '#FFEBEE')
        // gradient2.addColorStop(0.2, 'rgba(255, 235, 238, 0)')
        // var chartVisitors = new Chart(ctx2, {
        //     type: 'line',
        //     data: {
        //         labels: ['1', '2', '3', '4', '5', '6'],
        //         datasets: [
        //             {
        //                 data: [5, 5, 10, 10, 5, 3.5],
        //                 backgroundColor: gradient2,
        //                 borderColor: '#FF3856',
        //                 borderWidth: 2
        //             }
        //         ]
        //     },
        //     options: chartOptions
        // })

        //Продажи
        // var ctx3 = document.getElementById('chartSales').getContext('2d')
        // var gradient3 = ctx3.createLinearGradient(0, 0, 0, 400)
        // gradient3.addColorStop(0, '#D4FFEC')
        // gradient3.addColorStop(0.2, 'rgba(212, 255, 236, 0)')
        // var chartSales = new Chart(ctx3, {
        //     type: 'line',
        //     data: {
        //         labels: ['1', '2', '3', '4', '5', '6', '7', '8'],
        //         datasets: [
        //             {
        //                 data: [5, 7.5, 6, 9, 9, 8, 8, 10],
        //                 backgroundColor: gradient3,
        //                 borderColor: '#49CC98',
        //                 borderWidth: 2
        //             }
        //         ]
        //     },
        //     options: chartOptions
        // })
    }
}
</script>
